import { environment } from '../../../environments/environment';

export enum PartnerKey {
	Default = 'default',
	WellsFargo = 'wellsFargo',
}

export const mapPartnerIdToKey: (partnerId: string | null) => PartnerKey = (partnerId: string | null): PartnerKey => {
	switch (partnerId) {
		case environment.wfPartnerId:
			return PartnerKey.WellsFargo;
		default:
			return PartnerKey.Default;
	}
};
